module.exports = __webpack_public_path__ + "static/media/logo.dc2aba02.png";